import {computedFn, observable } from "@api";
import {action, computed} from 'mobx'
import { Orientation } from ".";

export class Rect {
    static empty() {
        return new Rect(0, 0, 0, 0);
    }

    @observable x: number = 0;
    @observable y: number = 0;
    @observable width: number = 100;
    @observable height: number = 28;

    constructor(x: number, y: number, width: number, height: number) {
        this.x = x ?? 0;
        this.y = y ?? 0;
        this.width = width;
        this.height = height;
    }

    static fromElement(element: Element) {
      let {x, y, width, height} = element.getBoundingClientRect();
      return new Rect(x, y, width, height);
    }

    clone = () => {
        return new Rect(this.x, this.y, this.width, this.height);
    }

    equals(rect: Rect) {
        if (!rect) return false

        if (this.x === rect.x && this.y === rect.y && this.width === rect.width && this.height === rect.height) {
            return true;
        } else {
            return false;
        }
    }

    @computed  get bottom() {
        return this.y + this.height;
    }

    @computed get right() {
        return this.x + this.width;
    }

    @action positionElement = (element: HTMLElement, position?: string) => {
        // console.debug(`positionElement`, {element, position})
        this.styleWithPosition(element.style, position);
    }

    styleWithPosition = (style: Record<string, any>, position: string = "absolute") => this._styleWithPosition(style, position)

    private _styleWithPosition = (style: Record<string, any>, position: string = "absolute") => {
        const {x, y, width, height} = this
        style.left = Math.max(0, x ?? 0) + "px"
        style.top = `${y ?? 0}px`
        style.width = Math.max(0, width ?? 100) + "px"
        style.height = Math.max(0, height ?? 28) + "px"
        style.position = position

        const {left, top} = style
        // console.log({me: this, left, top, width: style.width, height: style.height, position})
        return style
    }

    contains = (x: number, y: number) => {
        if (this.x <= x && x <= this.right && this.y <= y && y <= this.bottom) {
            return true
        } else {
            return false
        }
    }

    removeInsets(insets: { top: number; left: number; bottom: number; right: number }) {
        return new Rect(this.x + insets.left, this.y + insets.top, Math.max(0, this.width - insets.left - insets.right), Math.max(0, this.height - insets.top - insets.bottom));
    }

    centerInRect(outerRect: Rect) {
        this.x = (outerRect.width - this.width) / 2;
        this.y = (outerRect.height - this.height) / 2;
    }

    /** @hidden @internal */
    _getSize = (orientation: Orientation) => {
        let prefSize = this.width;
        if (orientation === Orientation.VERT) {
            prefSize = this.height;
        }
        return prefSize;
    }

    toString = () => {
        return "(Rect: x=" + this.x + ", y=" + this.y + ", width=" + this.width + ", height=" + this.height + ")";
    }
}



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/Rect.ts